import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import {
  TableErrorResponse,
  OptionsClass,
  QueryParamsEntitiesV3
} from "./MainApp";
import { PaginationV2 } from "./Pagination";

export class UrsaCode {
  ursaCode = "";
  "3lc": string[] = [];
  area: string[] = [];
  postalCode: string[] = [];
  isActive = false;

  constructor(fields?: Partial<UrsaCode>) {
    Object.assign(this, fields);
  }
}

export class UrsaCodeListRequest {
  q = "";
  status = new OptionsClass();
  page = 1;
  perPage = 20;

  constructor(fields?: Partial<UrsaCodeListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
        status: this.status.value
      })
    ).queryString;
  }
}

export class UrsaCodeList {
  data: UrsaCode[] = [];
  pagination = new PaginationV2();
  loading = false;
  error = new TableErrorResponse();
  params = new UrsaCodeListRequest();

  constructor(fields?: Partial<UrsaCodeList>) {
    Object.assign(this, fields);

    if (fields?.pagination) {
      this.pagination = new PaginationV2(fields.pagination);
    }

    if (fields?.data) {
      this.data = fields.data.map((item: UrsaCode) => new UrsaCode(item));
    }
  }
}

export class UrsaCodeDetail {
  ursaCode = "";
  threeLetterCode: string[] = [];
  area: string[] = [];
  postalCode: string[] = [];
  isActive = false;
  createdAt = "";
  createdByName = "";
  updatedAt = "";
  updatedByName = "";

  constructor(fields?: Partial<UrsaCodeDetail>) {
    Object.assign(this, fields);
  }
}
